import TEALIUM from "../../../../enums/tealium-enums";
import { track } from "../../../../util/tealium";

export const profileProfileTabErrorTrack = () => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.GLOBAL_CML, "profile_profile_tab_error", "");
};
